import React, { useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import ModalBase from "../../../../components/common/modal/ModalBase";
import Number from "./Number";
import { useSelector } from "react-redux";
import { cloneDeep } from "lodash";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { useBackdropContext } from "../../../../contexts/backdrop/BackdropProvider";
import { asyncPutData } from "../../../../utils/httpRequests";
import { useKitchenContext } from "../../KitchenPage";

interface IComplete {
  slDaCheBien: number;
  slCanCheBien: number;
  data: any;
}

function Complete({ data, slDaCheBien, slCanCheBien }: IComplete) {
  const token = useSelector((state: any) => state.auth.token);
  const app = useSelector((state: any) => state.app.data);
  const { currentHd } = useSelector((state: any) => state.kitchen);
  const { showAlert } = useAlertContext();
  const { setOpenBackdrop } = useBackdropContext();
  const { setLoad } = useKitchenContext();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [number, setNumber] = useState<number>(0);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSave = async () => {
    try {
      setOpenBackdrop?.(true);
      const currentHdClone = cloneDeep(currentHd);
      const details = currentHdClone?.details || [];
      const index = details.findIndex(
        (item: any) => item.ma_vt === data?.ma_vt
      );
      if (index < 0) return;
      const oldSlXuat = details[index].sl_xuat || 0;
      details[index].sl_xuat = oldSlXuat + number;
      const resp = await asyncPutData({
        apiCode: "pbl_nh",
        token,
        idApp: app?._id,
        id: currentHd?._id,
        data: currentHdClone,
      });
      if (resp?.status !== 200) {
        showAlert({
          type: "error",
          message:
            resp?.data?.error ||
            resp?.data?.message ||
            "Lỗi khi cập nhật số lượng",
        });
        return;
      }
      setLoad((prev) => prev + 1);
    } finally {
      setOpenBackdrop?.(false);
    }
  };

  useEffect(() => {
    setNumber(slCanCheBien || 0);
  }, [slCanCheBien, openModal]);

  return (
    <>
      <ModalBase
        title="Hoành thành"
        width="400px"
        open={openModal}
        handleClose={handleCloseModal}
        actions={[
          <Button
            key={1}
            onClick={handleCloseModal}
            size="small"
            variant="contained"
            color="error"
            sx={{
              boxShadow: "none",
              color: "common.white",
              textTransform: "none",
              "&:hover": { boxShadow: "none" },
            }}
          >
            Đóng
          </Button>,
          <Button
            key={2}
            onClick={handleSave}
            size="small"
            variant="contained"
            color="primary"
            sx={{
              boxShadow: "none",
              color: "common.white",
              textTransform: "none",
              "&:hover": { boxShadow: "none" },
            }}
          >
            Lưu
          </Button>,
        ]}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={0.5}
        >
          <Box sx={{ width: "130px" }}>
            <Number
              defaultValue={number}
              max={slCanCheBien}
              onNumberChange={setNumber}
            />
          </Box>
          <Typography>/</Typography>
          <Typography>{slCanCheBien} cần chế biến</Typography>
        </Stack>
      </ModalBase>
      <Stack alignItems="center">
        <Button
          onClick={() => setOpenModal(true)}
          size="small"
          variant="contained"
          color="primary"
          sx={{
            boxShadow: "none",
            color: "common.white",
            textTransform: "none",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Hoàn thành
        </Button>
        <Typography sx={{ fontSize: "12px" }}>Đã xong {slDaCheBien}</Typography>
      </Stack>
    </>
  );
}

export default Complete;
